export default "__VITE_ASSET__f3b37ab0__"